import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=41047b5d&"
import script from "./ImageUpload.vue?vue&type=script&lang=ts&"
export * from "./ImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports